import { createActionGroup, emptyProps, props } from '@ngrx/store';
import type { HomePage } from '../../api/api-types';

export const actions = createActionGroup({
    source: 'home',
    events: {
        'Load Home': emptyProps(),
        'Load Home Success': props<{ home: HomePage }>(),
        'Load Home Failure': props<{ error: string }>(),
    },
});
